import { render, staticRenderFns } from "./SenderWarehouse.vue?vue&type=template&id=18ce3f7e"
import script from "./SenderWarehouse.vue?vue&type=script&lang=js"
export * from "./SenderWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports